module.exports = __webpack_public_path__ + "static/img/001.f9c1a8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lengdongzhan/001.png
// module id = KNJr
// module chunks = 15